/** One capture listener survives both cart section replacements and drawer opens. */
(() => {
  if (window.lilaCartImageFallbackInstalled) return;
  window.lilaCartImageFallbackInstalled = true;
  function onImageError(event) {
    const image = event.target;
    if (!(image instanceof HTMLImageElement)) return;
    if (image.hasAttribute('data-cart-neutral-fallback')) {
      image.removeAttribute('data-cart-neutral-fallback');
      image.removeAttribute('src');
      image.style.visibility = 'hidden';
      return;
    }
    if (!image.hasAttribute('data-cart-preview-image')) return;
    const fallback = image.getAttribute('data-cart-image-fallback');
    image.removeAttribute('data-cart-preview-image');
    image.removeAttribute('srcset');
    if (fallback) {
      image.setAttribute('data-cart-neutral-fallback', '');
      image.src = fallback;
    } else {
      image.removeAttribute('src');
      image.style.visibility = 'hidden';
    }
  }
  document.addEventListener('error', onImageError, true);
  // A cached failure can precede this deferred asset on the initial cart load.
  function recoverCachedFailures() {
    document.querySelectorAll('img[data-cart-preview-image]').forEach((image) => {
      if (image.complete && image.naturalWidth === 0) onImageError({ target: image });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', recoverCachedFailures, { once: true });
  else recoverCachedFailures();
})();
